import { Box, Typography, Paper } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";

type DaxQueryDisplayProps = {
  daxQuery: string;
  textColor?: string;
};

export const DaxQueryDisplay = ({
  daxQuery,
  textColor,
}: DaxQueryDisplayProps) => {
  if (!daxQuery) {
    return null;
  }

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      <Typography
        variant="subtitle2"
        sx={{ mb: 1, fontWeight: "bold", color: textColor, display: "flex", alignItems: "center", gap: 0.5 }}
      >
        <CodeIcon fontSize="small" />
        DAX Query
      </Typography>
      <Paper
        sx={{
          p: 1.5,
          bgcolor: "rgba(0, 0, 0, 0.05)",
          borderRadius: 1,
          border: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="body2"
          component="pre"
          sx={{
            fontFamily: "monospace",
            fontSize: "0.85rem",
            margin: 0,
            whiteSpace: "pre-wrap",
            wordBreak: "break-all",
            color: "#333",
          }}
        >
          {daxQuery}
        </Typography>
      </Paper>
    </Box>
  );
};
